import { compose, withProps } from 'recompose';
import NumberInput from '../../../se/components/inputs/NumberInput';

export default compose(withProps({ placeholder: 'e.g., 600', required: true }))(NumberInput);
